import { c as _c } from "react/compiler-runtime";
import { isDevelopmentBuild } from '@/utils/is-development-build';
import type React from 'react';
export const ConveniatLogo: React.FC<{
  className?: string;
}> = t0 => {
  const $ = _c(7);
  const {
    className
  } = t0;
  const ICON_COLOR = isDevelopmentBuild() ? "#520000" : "#47564C";
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="75" height="75" fill="url(#pattern0_0_1)" fillOpacity="0" />;
    t2 = <circle cx="37.5" cy="37.5" r="36" stroke={ICON_COLOR} fill="#fff" strokeWidth="3" />;
    t3 = <path d="M16.4783 45.8427C16.4492 45.8593 16.4173 45.8646 16.3877 45.8796H24.0941C28.3348 40.8075 31.7103 35.1598 33.1141 28.7697V24.5258C31.596 29.0215 29.208 32.9888 26.2733 36.6173C23.3818 40.1927 20.2977 43.6579 16.4783 45.8427Z" fill={ICON_COLOR} />;
    t4 = <path d="M37.4999 -6.10352e-05C16.8224 -6.10352e-05 0 16.8226 0 37.5008C0 58.1774 16.8224 75 37.4999 75C58.1776 75 75 58.1774 75 37.5008C75 16.8226 58.1776 -6.10352e-05 37.4999 -6.10352e-05ZM37.4999 74.2517C19.9374 74.2517 5.22141 61.8664 1.60641 45.3739C4.02842 43.8673 5.62744 42.8595 8.18171 41.1988C14.8696 36.8516 21.2604 32.0203 26.9838 26.1443C29.1929 23.8765 31.2255 21.425 33.1147 18.7624V14.3227H34.0098V19.1194C34.1193 19.3657 34.223 19.6181 34.3355 19.8594C38.5493 28.8663 45.3893 35.0098 52.8142 40.5117C51.0982 38.85 49.3291 37.2519 47.6804 35.5098C46.0197 33.7536 44.4774 31.8555 42.9611 29.8989C51.8639 38.1886 62.3838 42.0667 73.3171 45.7049C69.5781 62.0311 54.9436 74.2517 37.4999 74.2517Z" fill={ICON_COLOR} />;
    t5 = <path d="M53.9671 53.3255V54.7547L50.4282 62.8533H48.0328L51.449 55.1223H48.2912V56.6738H46.3313V53.3255H53.9671ZM45.5986 59.7362V61.492H38.3981V60.2671L42.087 57.3544C42.8491 56.7555 43.0668 56.3743 43.0668 55.9388C43.0668 55.3671 42.5633 54.9726 41.5832 54.9726C40.6849 54.9726 40.0178 55.3128 39.5962 55.9524L37.949 55.0133C38.684 53.8564 40.0043 53.1622 41.7465 53.1622C43.8972 53.1622 45.2857 54.2648 45.2857 55.7347C45.2857 56.7145 44.9455 57.4088 43.6523 58.4024L41.9644 59.7362H45.5986ZM35.284 57.4088C35.284 55.8298 34.4675 54.9862 33.3377 54.9862C32.2079 54.9862 31.3914 55.8298 31.3914 57.4088C31.3914 58.9877 32.2079 59.8316 33.3377 59.8316C34.4675 59.8316 35.284 58.9877 35.284 57.4088ZM29.1864 57.4088C29.1864 54.8908 30.9284 53.1622 33.3377 53.1622C35.7467 53.1622 37.4753 54.8908 37.4753 57.4088C37.4753 59.9269 35.7467 61.6556 33.3377 61.6556C30.9284 61.6556 29.1864 59.9269 29.1864 57.4088ZM28.2087 59.7362V61.492H21.0082V60.2671L24.697 57.3544C25.4592 56.7555 25.6768 56.3743 25.6768 55.9388C25.6768 55.3671 25.1734 54.9726 24.1933 54.9726C23.295 54.9726 22.6279 55.3128 22.2059 55.9524L20.5591 55.0133C21.2941 53.8564 22.6143 53.1622 24.3566 53.1622C26.5072 53.1622 27.8957 54.2648 27.8957 55.7347C27.8957 56.7145 27.5552 57.4088 26.2621 58.4024L24.5745 59.7362H28.2087Z" fill={ICON_COLOR} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== className) {
    t6 = <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}{t3}{t4}{t5}</svg>;
    $[5] = className;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};